if (!customElements.get('wiggensbach-hero')) {
  customElements.define(
    'wiggensbach-hero',
    class WiggensbachHero extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.timer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-wig-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-wig-hero-dot]'));

        if (this.slides.length <= 1) return;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(parseInt(dot.dataset.slideIndex, 10) || 0);
            this.restartAutoplay();
          });
        });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      goTo(index) {
        const nextIndex = (index + this.slides.length) % this.slides.length;
        if (nextIndex === this.currentIndex) return;

        this.slides[this.currentIndex]?.classList.remove('is-active');
        this.dots[this.currentIndex]?.classList.remove('is-active');
        this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

        this.currentIndex = nextIndex;

        this.slides[this.currentIndex]?.classList.add('is-active');
        this.dots[this.currentIndex]?.classList.add('is-active');
        this.dots[this.currentIndex]?.setAttribute('aria-selected', 'true');
      }

      next() {
        this.goTo(this.currentIndex + 1);
      }

      startAutoplay() {
        if (this.dataset.autoplay !== 'true' || this.slides.length <= 1 || this.timer) return;

        const delay = parseInt(this.dataset.delay, 10) || 6000;
        this.timer = window.setInterval(() => this.next(), delay);
      }

      stopAutoplay() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  );
}
